<template>
    <div id="quantityCalculation">
        <el-form ref="searchForm" :model="searchForm" style="width:100%" :inline="true" :label-position="labelPosition">
            <el-form-item  style="margin-bottom:15px">
                <el-date-picker
                    value-format="yyyy-MM-dd"
                    style="width: 100%;"
                    v-model="valueTime3"
                    type="date"
                    :clearable="false"
                    format="yyyy 年 M 月 d 日"
                    placeholder="选择日期">
                </el-date-picker>
            </el-form-item>

            <el-form-item style="margin-bottom: 15px;">
                <el-button type="primary" size="medium" @click="onSubmit('searchForm')">查询</el-button>
            </el-form-item>
        </el-form>
        <el-card class="box-card fr" style="width: 100%;">
            <el-table
                :data="returnData"
                border
                id="tableId"
                :header-cell-style="{'text-align':'onsiteDate'}"
                style="width: 100%">
                <el-table-column
                    align="center"
                    prop="onsiteDate"
                    label="时间">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="onsiteTimeEnd"
                    label="时间段">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="memo"
                    label="单量">
                    <template slot-scope="scope">
                        <span :style="{color:  parseInt(scope.row.memo) > 30 ? 'red' : 'blue'}">{{scope.row.memo}}</span>
                    </template>  
                </el-table-column>
            </el-table>
        </el-card>
    </div>
</template>
<script>
    let moment = require("moment");
    import { orderHourCount,queryRefundList,applyRefund,checkRefund,getOrderList } from "../../api/order";
    import {queryUser} from '@/api/api';
    import store from '../../store/store';
    import {genUpToken} from "../basicSetting/com/qiniuToken.js";
    import {getPermission} from '../../api/authRequest'
    export default {
        name: 'quantityCalculation',
        data () {
            return {
                //valueTime3:new Date().moment,
                valueTime3:this.addDate(),
                systemTime:'',
                pickingRelativeList:[],
                pickingUserAllList:[],
                //分页变量
                pages:{
                    total: 0,
                    page: 1,
                    pageSize: 20,
                },
                labelPosition:'left',
                searchForm:{
                    status:'',          //退款状态
                    orderNo:'',         //订单号
                    refundTimeFrom:'',  //申请开始时间
                    refundTimeTo:'',    //申请结束时间
                    staffName:'',       //申请人姓名
                    refundNo: '',       //退款申请编号
                },
                returnData: [],
                dislogModel:false,
                dialogModelStatus: "",
                textModelMenu: {
                    update: "退款申请详情",
                    create: "新建退款申请"
                },
                postData:{token:''},
                imageUrl: [],       //退款图片
                fileList:[],     //图片查看
                dialogImageUrl:"",  //预览图片
                dialogVisible: false,
                acceptImage: "image/jpeg,image/jpg,image/png",
                qiniuaddr: 'pic.allscs.cn',// 这是七牛云空间的外链默认域名
                ruleImg:'imageView2/0/q/75|imageslim',//规则
                isReject:false,
                modelForm:{
                    orderNo: '',
                    refundMoney: '',
                    refundReason: "",
                    images:"",
                },
                modelFormRules:{//validateRoleName
                    orderNo: [{ required: true, message: "请输入关联工单", trigger: "blur"}],
                    status: [{ required: true, message: "请选择退款类型", trigger: "blur" }],
                    refundMoney: [{ required: true, message: "请输入退款金额", trigger: "blur" }],
                    refundReason: [{ required: true, message: "请输入退款原因", trigger: "blur" }],
                },
                 basicsAuth:{
                    apply_refund:false
                }
               
            }
        },
        
        mounted () {
		 this.basicsAuth.apply_refund = getPermission('/api/workOrder/refund/apply_refund');
        },
        created(){
            var token = "";
            var policy = {};
            var bucketName = 'hohofast';
            var AK ='VYiFElH26Am5EbV9T3nACEfNt6xBRz6gEREDFlis';
            var SK = 'sFELHoXSwB8NpiWpPj2Wk7theJCO7Iil-2rwSj31';
            var deadline = Math.round(new Date().getTime() / 1000) + 3600;
            policy.scope = bucketName;
            policy.deadline = deadline;
            token=genUpToken(AK, SK, policy);
            this.postData.token=token;
            this.getRefundList();
            this.queryUserAllList();
        },
        methods: {
            addDate () {
            let nowDate = new Date()
            let date = {
                year: nowDate.getFullYear(),
                month: nowDate.getMonth() + 1,
                date: nowDate.getDate()
            }
             this.systemTime = this.formatDate(date.year,date.month,date.date),
             console.log(this.systemTime);
             return this.systemTime;
            },
            //查询所有系统账号
            queryUserAllList(){
                queryUser({type:2}).then(res =>{
                    if(res.data.status == '100'){
                        this.pickingUserAllList = res.data.results
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //上传成功
            handleModelAvatarSuccess(res, file) {
                this.imageUrl.push('http://' + this.qiniuaddr + '/' + res.key+'?imageslim');
                this.modelForm.images = this.imageUrl.join(',');
            },
            //删除图片
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            //预览图片
            handlePreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            //上传前判断
            beforeAvatarUpload(file) {
                const isPNG = file.type === 'image/png';
                const isJPG = file.type === 'image/jpeg';
                const isLt2M = file.size / 1024 / 1024 < 10;
                if (!isJPG&&!isPNG) {
                    this.$message.error('上传头像图片只能是 JPG 格式 和Png 格式!');
                }
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 10MB!');
                }
                return isLt2M;
            },
            //提交上传图片
            submitUpload() {
                this.imageUrl = [];
                this.$refs.upload.submit();
            },
            //获取关联订单号
            getOrderListData(){
                getOrderList({orderNo:this.modelForm.orderNo}).then(res => {
                    if (res.data.status==100) {
                        if(res.data.results.length == 0 ){
                            this.$message({
                                message: '关联工单号错误，请重新输入',
                                type: "warning"
                            });
                            
                        }else{
                            this.addModelFormSubmitBtn('modelForm');
                        }
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //关闭弹出框
            emptyModelDialog() {
                this.dislogModel = false;
                Object.keys(this.modelForm).forEach(key => this.modelForm[key]= '');
                this.$refs['modelForm'].resetFields();
                this.imageUrl = [];
                this.fileList = [];
                this.isReject = false;
            },
            //确定新建退款申请
            addModelFormSubmitBtn(formname){
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        const loading = this.$loading({
                            lock: true,
                            text: '提交中...',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.5)'
                        });
                        this.submitUpload();
                        const timer1 = setTimeout(()=>{
                            if(!this.modelForm.images){
                                this.$message({
                                    message: '请上传相关图片',
                                    type: "warning"
                                });
                                loading.close();
                            }else{
                                this.submitNewModel();
                                loading.close();
                                clearTimeout(timer1)
                            }
                        },1000)                    
                    }else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            },
            //提交申请
            submitNewModel(){
                applyRefund(this.modelForm).then(res => {
                    if (res.data.status==100) {
                        this.$message({
                            message: '申请退款成功',
                            type: "success"
                        });
                        /*关闭弹窗，重置输入框*/
                        this.emptyModelDialog();
                        /*刷新*/
                        this.getRefundList();
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            confirmBtn(num){
                let message = num == 0 ? '确认驳回申请吗？' : '确认退款已完成？';
                this.$confirm(message, '提示', {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    (num == 0) ? this.submitConfirmModel(0) : this.submitConfirmModel(1);
                }).catch(action => {
                    (num == 0) ? (this.isReject = false) : '';
                });
            },
            //退款确认 type:0 驳回 type:1确认
            submitConfirmModel(type){
                let para = {};
                if(type == 0){
                    if(!this.modelForm.attribute1){
                        this.$message({
                            message: '请输入驳回原因',
                            type: "warning"
                        });
                        return
                    }
                    para = {
                        id:this.modelForm.id,
                        status:"4",
                        attribute1:this.modelForm.attribute1
                    }
                }else{
                    para = {
                        id:this.modelForm.id,
                        status:"3",
                    }
                }
                checkRefund(para).then(res => {
                    const loading = this.$loading({
                        lock: true,
                        text: '提交中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.5)'
                    });
                    if (res.data.status==100) {
                        this.$message({
                            message: res.data.message,
                            type: "success"
                        });
                        /*关闭弹窗，重置输入框*/
                        this.emptyModelDialog();
                        /*刷新*/
                        this.getRefundList();
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                    loading.close();
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //新建退款
            // newModel() {
                // Object.keys(this.modelForm).forEach(key => this.modelForm[key]= '');
                // this.dislogModel = true
                // this.dialogModelStatus = "create";
            // },
            //查看退款详情
            checkModel(item) {
                this.dislogModel = true
                this.dialogModelStatus = "update";
                this.modelForm = Object.assign({}, item);
                this.fileList = [];
                if(this.modelForm.images){
                    this.modelForm.images.split(',').forEach((item,index)=>{
                        this.fileList.push({
                            name:'',
                            url:item
                        })
                    })
                }
            },
            //获取退款申请管理列表
            getRefundList(){
                console.log('验证未通过');
                let query ={
                    refundTimeFrom : this.valueTime3
                }
                 console.log(this.valueTime3);
                this.searchForm.startRow = this.pages.page;
                this.searchForm.pageSize = this.pages.pageSize;
                orderHourCount({onsiteDate:this.valueTime3}).then(res => {       
                    if (res.data.status==100) {            
                            this.returnData = res.data.results
                            this.pages.total = res.data.results.total
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },

        getOrderEvents(){
            let query ={
                 orderNo : this.orderInfoForm.orderNo
                }
        selectWorkOrderIncident(query).then(res =>{
            if(res.data.status == '100' ){
              this.orderEvents = res.data.results
            }
         })
        },
            formatDate(year,month, date) {
                return [year, month, date].map(this.formatNumber).join('-')
            },
            formatNumber(n) {
                n = n.toString()
                return n[1] ? n : '0' + n
            },

            handleSizeChange(val) {
                this.pages.pageSize = val
                this.getRefundList()
            },
            handleCurrentChange(Page) {
                this.pages.page = Page
                this.getRefundList()
            },
            //
            onSubmit(formname) {
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        if(!this.valueTime3){
                            console.log('验证未通过1');
                            this.searchForm.refundTimeFrom = ''
                            this.searchForm.refundTimeTo = ''
                        }else if (this.valueTime3.length == 0) {
                            console.log('验证未通过2');
                            this.searchForm.refundTimeFrom = ''
                            this.searchForm.refundTimeTo = ''
                        }else{
                            console.log('验证未通过3');
                            this.searchForm.refundTimeFrom = this.moment(this.valueTime3[0]).format("YYYY-MM-DD");
                            this.searchForm.refundTimeTo = this.moment(this.valueTime3[1]).format("YYYY-MM-DD");
                        }
                        this.getRefundList()
                    } else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            }
        },
        computed: {},
        watch: {}
    }
</script>

<style type="text/css" lang="scss" scoped>
    .hide-upload{
        .el-upload {
            display: none;
        }
    } 
    #quantityCalculation{
        font-size: 14px;
        .headerT{
            margin:0 0 15px 0;
        }
        tr.el-table__row{
            cursor: pointer;
        }
        input.el-input__inner{
            padding-right:25px; 
        }
        .active-code{
            color:#409EFF
        }
        .avatar {
            width: 178px;
            height: 178px;
            display: inline-block;
        }
        .yuan{
            position:relative;
            &:after{
                position:absolute;
                right:0;
                content:'元';
                font-size:14px;
                color:#666;
                line-height:40px;
                width:30px;
                height:40px;
                top:0;
                display:block
            }
        }
    }

</style>



// WEBPACK FOOTER //
// quantityCalculation.vue?44a2ce9c